<template>
  <div class="panel panel-default">
    <!-- Default panel contents -->
    <div class="panel-heading">{{ titulo }}</div>

    <!-- Table -->
    <table class="table table-striped table-hover table-condensed table-responsive">
      <thead>
        <tr>
          <th class="text-center">Nome</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="participante in lista">
          <td class="text-center">{{ participante.nome }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TabelaGP',
  props: [
    'lista',
    'titulo'
  ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// TabelaCaminhantes.vue?77e41fb0